import script from "./WelcomeBoxContentLV.vue?vue&type=script&setup=true&lang=js"
export * from "./WelcomeBoxContentLV.vue?vue&type=script&setup=true&lang=js"

import "./WelcomeBoxContentLV.vue?vue&type=style&index=0&id=7031b30b&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7031b30b"]])

export default __exports__